import React from 'react';
import AccordianHeader from './accordian-header';

const AccordianSection = (props) =>
  <div className={`accordian-section ${props.isActive ? 'active' : ''}`}>
    <AccordianHeader
      sectionKey={props.sectionKey}
      textColor={props.textColor}
      handleClick={props.handleClick}
      idx = {props.idx}
    >
      {props.preTitle}
      {props.title}
    </AccordianHeader>
    <div className="accordian-section-subcontent clean-scrollbars">{props.children}</div>
  </div>
;

export default AccordianSection;
